export const actions = {
    SET_SELECTED_SEARCH: "SET_SELECTED_SEARCH",
};

export const setSelectedSearch = (object: any) => {
    return (dispatch) => {
        dispatch({
            type: actions.SET_SELECTED_SEARCH,
            payload: object
        })
    }
};



// WEBPACK FOOTER //
// ./app/actions/savedSearchActions.ts